// extracted by mini-css-extract-plugin
export default {"container":"PerPage_container__Ekw8z"};